import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=676a2373&scoped=true&"
import script from "./Program.vue?vue&type=script&lang=js&"
export * from "./Program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676a2373",
  null
  
)

export default component.exports